import { useEffect, useState } from "react";
import { ACTIONS, STATUTS, date, messageErreur } from "./libelles";
import { ErreurBase, appeler } from "./supabase";
import type { LigneJournal } from "./types";

/** Qui a fait quoi, du plus récent au plus ancien, tous mots confondus. */
export function Journal(props: { readonly onOuvrir: (id: string) => void }) {
  const [lignes, setLignes] = useState<readonly LigneJournal[] | null>(null);
  const [erreur, setErreur] = useState<string | null>(null);

  useEffect(() => {
    appeler<LigneJournal[]>("admin_journal", { p_limite: 200 })
      .then(setLignes)
      .catch((e: unknown) => setErreur(messageErreur(e instanceof ErreurBase ? e.code : "erreur_inconnue")));
  }, []);

  return (
    <section>
      <h1>Journal</h1>
      <p className="discret">Les deux cents derniers changements du corpus, avec qui les a faits et pourquoi.</p>
      {erreur !== null && (
        <p role="alert" className="erreur">
          {erreur}
        </p>
      )}
      {lignes === null && erreur === null && <p role="status">Chargement…</p>}
      {lignes !== null && (
        <table className="journal">
          <thead>
            <tr>
              <th scope="col">Quand</th>
              <th scope="col">Qui</th>
              <th scope="col">Mot</th>
              <th scope="col">Quoi</th>
              <th scope="col">Pourquoi</th>
            </tr>
          </thead>
          <tbody>
            {lignes.map((ligne) => (
              <tr key={`${ligne.entree_id}-${ligne.version}`}>
                <td>{date(ligne.le)}</td>
                <td>{ligne.par}</td>
                <td>
                  <button type="button" className="lien" onClick={() => props.onOuvrir(ligne.entree_id)}>
                    {ligne.mot}
                  </button>
                </td>
                <td>
                  {ACTIONS[ligne.action]}
                  {ligne.action === "statut" && ` → ${STATUTS[ligne.statut]}`}
                </td>
                <td>{ligne.motif ?? "—"}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
